import React from "react";
import {
  BackEndSkills,
  FrontEndSkills,
  Tools,
 
} from "../Component/skillImages";
import { Box, Center, Heading } from "@chakra-ui/react";
import SkillBox from "../Component/SkillBox";

function Skills() {
  //   const { theme } = useContext(ThemeContext);

  const skillBoxStyle = {
    backgroundColor: "white",
    boxShadow: `0px 0px 20px #7bdeff`,
  };

  return (
    <Box bg="white">
      <Box pt="10px">
        <Heading color="#00ade7" size="lg">
        My Tech Skills
        </Heading>
      </Box>

      <Box >
        <Heading p="20px" size="md">Front End Languages</Heading>

        <SkillBox skillObject={FrontEndSkills} />

        <Box >
          <Heading p="20px" size="md">Back End Languages</Heading>

          <SkillBox skillObject={BackEndSkills} />
        </Box>

        <Box >
          <Heading p="20px" size="md" >Tools</Heading>

          <SkillBox skillObject={Tools} />
        </Box>
      </Box>
    </Box>
  );
}

export default Skills;
